import { render, staticRenderFns } from "./SceneExport.vue?vue&type=template&id=870e10ec&scoped=true"
import script from "./SceneExport.vue?vue&type=script&lang=js"
export * from "./SceneExport.vue?vue&type=script&lang=js"
import style0 from "./SceneExport.vue?vue&type=style&index=0&id=870e10ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870e10ec",
  null
  
)

export default component.exports